import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  class: "card-header border-0 pt-6",
  style: {"position":"sticky","top":"45px","background-color":"white","z-index":"1"}
}
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = { style: {"width":"100%","margin-left":"5px"} }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table table-striped gy-5 gs-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold fs-4 text-gray-800 border-bottom-2 border-gray-200" }),
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bold fs-4 text-gray-800 border-bottom-2 border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Opsiyon adı"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Açma - Kapama")
  ])
], -1)
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control form-control-solid w-250px ps-14",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterparams) = $event)),
            placeholder: "Opsiyon Filtrele"
          }, null, 512), [
            [_vModelText, _ctx.filterparams]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterStatus = null ))
          }, " Tüm Opsiyonlar "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterStatus = _ctx.ProductStatus.Closed ))
          }, " Kapalı Opsiyonlar "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-light-primary me-3",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterStatus = _ctx.ProductStatus.Open ))
          }, " Açık Opsiyonlar ")
        ])
      ]),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.filtervaluem?.length ?? 0) + " Opsiyon bulundu ", 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("table", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtervaluem, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(item.name), 1),
              _createElementVNode("td", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((item.integrationOptions as IntegrationOption[]), (iOption, ix) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: ix,
                    onClick: ($event: any) => (
                      _ctx.changeStatusForIOption(
                        iOption,
                        iOption.option?.Status == _ctx.ProductStatus.Open
                          ? _ctx.ProductStatus.Closed
                          : _ctx.ProductStatus.Open
                      )
                    ),
                    style: _normalizeStyle(
                      iOption?.option?.Status == _ctx.ProductStatus.Open
                        ? 'background-color: ' +
                          _ctx.IntegrationOption.statusColor(
                            iOption,
                            iOption.option.Status
                          )
                        : 'background-color: gray'
                    ),
                    type: "button",
                    class: "btn btn-primary er fs-6 px-8 py-4"
                  }, _toDisplayString(_ctx.IntegrationOption.firstLetter(iOption)), 13, _hoisted_12))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}